__turbopack_context__.v({
  "fade-in-ux308f6": "emptyList-module-scss-module__Ejz-za__fade-in-ux308f6",
  "text": "emptyList-module-scss-module__Ejz-za__text",
  "title": "emptyList-module-scss-module__Ejz-za__title",
  "title-icon": "emptyList-module-scss-module__Ejz-za__title-icon",
  "title-icon-background": "emptyList-module-scss-module__Ejz-za__title-icon-background",
  "wrapper": "emptyList-module-scss-module__Ejz-za__wrapper",
});
